/**
 * Central rules for when the global scroll-to-top on navigation should NOT run.
 *
 * Add cases here as needed, or pass `location.state.preserveScroll === true` from any navigation.
 */

export const JOB_SEARCH_RESTORE_STORAGE_KEY = "jobuwin-applicant-job-search-restore";

/**
 * @param {{ pathname: string, state: unknown }} location — React Router `location`
 * @param {string} navigationType — from `useNavigationType()` (`POP` | `PUSH` | `REPLACE`)
 */
export function shouldSkipGlobalScrollToTop(location, navigationType) {
  const s = location.state && typeof location.state === "object" ? location.state : null;

  if (s?.preserveScroll === true) return true;

  // Applicant job search: return from job detail with scroll and/or last-opened result
  if (location.pathname === "/job-search" && s?.searchUiState && typeof s.searchUiState === "object") {
    const ui = s.searchUiState;
    const y = ui.scrollY;
    if (typeof y === "number" && Number.isFinite(y)) return true;
    if (typeof ui.lastOpenedJobId === "string" && ui.lastOpenedJobId.trim()) return true;
  }

  // Same route, browser Back — state may be missing; snapshot may carry scroll / job id
  if (location.pathname === "/job-search" && navigationType === "POP") {
    try {
      const raw = window.sessionStorage.getItem(JOB_SEARCH_RESTORE_STORAGE_KEY);
      if (!raw) return false;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== "object") return false;
      const y = parsed.scrollY;
      if (typeof y === "number" && Number.isFinite(y)) return true;
      if (typeof parsed.lastOpenedJobId === "string" && parsed.lastOpenedJobId.trim()) return true;
    } catch {
      return false;
    }
  }

  // Hiring dashboard: session snapshot + restore flag (see HiringDashboardPage)
  if (location.pathname === "/hiring-dashboard" && s?.restoreHiringDashboard === true) return true;

  return false;
}
